var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9754 7.77458C16.3415 8.1407 16.3415 8.7343 15.9754 9.10041L10.6629 14.4129C10.2968 14.779 9.7032 14.779 9.33708 14.4129L4.02458 9.10041C3.65847 8.7343 3.65847 8.1407 4.02458 7.77458C4.3907 7.40847 4.9843 7.40847 5.35041 7.77458L10 12.4242L14.6496 7.77458C15.0157 7.40847 15.6092 7.40847 15.9754 7.77458Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.c09ce8d24795943fa39f32d60c2baf7c.svg";
export { ForwardRef as ReactComponent };